export class HoyaAlert {
  /**
   * Create a HoyaAlert
   * @param {string} id
   * @param {string[]} emails
   * @param {string} name
   * @param {string} label
   * @param {string} monitor_id
   * @param {string} organization
   * @param {string} side
   * @param {string} site
   * @param {number} threshold
   * @param {boolean} continuous
   * @param {string} user_id
   * @param {string} created_at
   */
  constructor(
    id,
    emails,
    name,
    label,
    monitor_id,
    organization,
    side,
    site,
    threshold,
    continuous,
    user_id,
    created_at
  ) {
    /** @type {string} */
    this.id = id;
    /**@type {string[]} */
    this.emails = emails;
    /**@type {string} */
    this.name = name;
    /**@type {string} */
    this.label = label;
    /**@type {string} */
    this.monitor_id = monitor_id;
    /**@type {string} */
    this.organization = organization;
    /**@type {string} */
    this.side = side;
    /**@type {string} */
    this.site = site;
    /**@type {number} */
    this.threshold = threshold;
    /**@type {boolean} */
    this.continuous = continuous;
    /**@type {string} */
    this.user_id = user_id;
    /**@type {Date} */
    this.created_at = new Date(created_at);
  }

  /**
   * Map data from api to instance of HoyaAlert
   * @returns {HoyaAlert} new instance with the mapped data
   */
  static fromApi({
    id,
    emails,
    name,
    label,
    monitor_id,
    organization,
    side,
    site,
    threshold,
    continuous,
    user_id,
    created_at,
  }) {
    return new HoyaAlert(
      id,
      emails,
      name,
      label,
      monitor_id,
      organization,
      side,
      site,
      threshold,
      continuous,
      user_id,
      created_at
    );
  }
}
